import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Body.scss';

export default class Body extends Component {
    static propTypes = {
        children: PropTypes.any,
        isOpen: PropTypes.bool,
        shouldRemoveBodyMargins: PropTypes.bool
    };

    render() {
        return (
            <div className={classNames('emvio-body', {
                'no-margins': this.props.shouldRemoveBodyMargins
            })}>
                {this.props.children}
            </div>
        );
    }
}
